export default "__VITE_ASSET__E7s13B7E__"